import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'simplebar/src/simplebar.css';
import 'leaflet/dist/leaflet.css';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { RecoilRoot } from 'recoil';

import { loadConfig } from './config';

async function startApp() {
    try {
        // โหลด config ก่อน
        await loadConfig();

        // โหลด App หลัง config โหลดเสร็จแล้ว
        const { default: App } = await import('./App');

        ReactDOM.render(
            <React.StrictMode>
                <HelmetProvider>
                    <BrowserRouter>
                        <RecoilRoot>
                            <App />
                        </RecoilRoot>
                    </BrowserRouter>
                </HelmetProvider>
            </React.StrictMode>,
            document.getElementById('root')
        );

    } catch (error) {
        console.error('Load config failed:', error);
    }
}

startApp();

reportWebVitals();